import React from 'react';

import { MerchantDetail } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

type MerchantContextT = {
  merchant: MerchantDetail | undefined;
  merchantVenues: Venue[] | undefined;
};

export type ValidMerchantContextT = {
  merchant: MerchantDetail;
  merchantVenues: Venue[];
};

export const MerchantContext = React.createContext<MerchantContextT>({
  merchant: undefined,
  merchantVenues: undefined,
});

export const isMerchantContext = (merchantContext: MerchantContextT): merchantContext is ValidMerchantContextT => {
  return merchantContext.merchant !== undefined && merchantContext.merchantVenues !== undefined;
};

export const useMerchantContext = () => {
  const merchantContext = React.useContext(MerchantContext);
  if (!isMerchantContext(merchantContext)) {
    throw new Error('useMerchantContext must be used within MerchantContextProvider');
  }
  return merchantContext;
};

export const MerchantContextProvider = MerchantContext.Provider;
